export const NAME = 'login';

export const SOCIAL_AUTH_LINK =
  'https://api.yoursapp.com/v1/auth/social/login/?provider=';
